import { Dropdown } from 'bootstrap/dist/js/bootstrap.esm.min'

Array.from( document.querySelectorAll( '.wp-toolkit .dropdown' ) )
     .forEach( dropdownNode => new Dropdown( dropdownNode ) )
